<template>
  <div id="userManage">
    <div class="data_head">
<!--      <div class="search_input">-->
<!--        <el-input  placeholder="输入日志内容（并按Enter键）"-->
<!--                  suffix-icon="iconfont icon-search" @keyup.enter.native="search()"></el-input>-->
<!--      </div>-->
<!--      <el-button class="searchB"  type="primary" @click="search()">查询</el-button>-->
      <el-button class="searchB"  type="primary" @click="createUser">创建用户</el-button>
    </div>
    <div class="table tableContent">
      <el-table :data="dataList" style="width: 100%" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
        <el-table-column align="center" prop="username" label="用户名"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
        <el-table-column align="center" prop="email" label="邮箱"></el-table-column>
        <el-table-column align="center" prop="roleId" label="角色权限">
          <template slot-scope="scope">
            <span>{{getPover(scope.row.roleId)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="buttonArr" size="mini" @click="alterPassword(scope.row)" type="primary">修改密码</el-button>
            <el-button class="buttonArr" size="mini" @click="handleDelete(scope.row)" type="danger">删除</el-button>
<!--            <el-button size="mini" @click="setInitData(scope.row)" type="warning">初始数据</el-button>-->
<!--            <el-button size="mini" @click="setInitValue(scope.row)" type="success">初始值</el-button>-->
          </template>
        </el-table-column>
      </el-table>
<!--      <div class="pagination">-->
<!--        <el-pagination-->
<!--          @current-change="handleCurrentChange" :current-page="pageCurrent"-->
<!--          :page-size="pageSize" layout="total,prev, pager, next, jumper"-->
<!--          :total="totalNum" class="pagination" background >-->
<!--        </el-pagination>-->
<!--      </div>-->
    </div>
    <AddUser :dialogAdd="dialogAdd" @update="getData"></AddUser>
    <AlterPassword :alterShow="alterShow" :userId="userId" @update="getData" ></AlterPassword>

  </div>
</template>

<script>
  import  AddUser from  './AddUser'
  import  AlterPassword from  './alterPassword'
    export default {
        name: "userManage",
        components:{AddUser,AlterPassword},
        data(){
            return{
                dataList:[],//列表数据
                pageCurrent:1,
                pageSize:10,
                totalNum:null,
                dialogAdd:{show:false},
                alterShow:{show:false},
                userId:null
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            //获取数据
            getData(){
                let req = {
                    "roleIds":[12,13]
                }
                this.$axios.post(`/api/monitor/user/list`,req).then(res => {
                    if(res.status == 200){
                        this.dataList=res.data.datas.values
                    }
                    return
                });
            },
            getPover(info){
                if(info==12){
                    return '超级管理员'
                }
                if(info==13){
                    return '普通用户'
                }
            },
            //创建用户
            createUser(){
                this.dialogAdd.show=true
            },
            //修改密码
            alterPassword(row){
                this.alterShow.show=true
                this.userId=row.userId
            },
            //删除
            handleDelete(row){
                this.$confirm('是否删除当前账号', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let req = {
                        userId:row.userId
                    }
                    this.$axios.post("/api/monitor/user/delete",req).then(res=>{
                        if(res.data.status==200){
                            this.$message.success('删除成功')
                            this.getData()
                        }else{
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            //搜索
            search(){},
        //    分页
            handleCurrentChange(){}
        }
    }
</script>


<style>

  #userManage .search_input .el-input__inner {
    background: #3457DE;
    border: 1px solid #3457DE;
    border-radius: 6px;
    width: 230px;
    font-size: 14px;
    color:#FFF;
  }

  #userManage .el-table{
    color: #A7CCF6;
  }

  #userManage .el-table__row {
    background-color: #0B3A68 !important;
  }

  #userManage .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: #021535;
  }

  #userManage .el-table td{
    border: unset;
  }

  #userManage .el-table th.is-leaf{
    border-bottom: none;
  }

  #userManage .el-pagination__total{
    color: #FFF;
  }

</style>


<style scoped>
  @import url("../../assets/css/style.css");

  .searchB{
    height: 40px;
    margin-left: 20px;
    background-color: #E68F02;
    border: #E68F02;
    color: #FFF;
  }

  .search_input{
    float: left;
    margin-left: 20px;
  }

  .pagination{
    /*margin-top: 30px;*/
    text-align: center;
  }
  .buttonArr {
    margin: 0 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/systemSetting/userManage.vue